import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { TargetIcon, SearchIcon, ClockIcon } from 'lucide-react';
const painPoints = [{
  icon: TargetIcon,
  text: 'Quieres generar ingresos… pero no sabes por dónde empezar'
}, {
  icon: SearchIcon,
  text: 'Has visto muchas opciones… pero ninguna clara'
}, {
  icon: ClockIcon,
  text: 'Sientes que estás perdiendo tiempo… y oportunidades'
}];
export function PainSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-6 bg-dark-secondary" data-id="element-106">
      <div className="max-w-5xl mx-auto" data-id="element-107">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-text-primary mb-16 text-center" data-id="element-108">
          Si estás aquí, probablemente te pasa esto:
        </motion.h2>

        <div className="max-w-2xl mx-auto space-y-5 mb-14" data-id="element-109">
          {painPoints.map((point, index) => {
          const Icon = point.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: index * 0.12
          }} className="flex items-start gap-4 p-6 bg-dark-bg/50 rounded-lg border border-dark-tertiary" data-id="element-110">
                <Icon className="w-6 h-6 text-accent flex-shrink-0 mt-1" data-id="element-111" />
                <p className="text-lg text-text-secondary" data-id="element-112">{point.text}</p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-center" data-id="element-113">
          <p className="text-xl md:text-2xl text-text-primary font-medium mb-3" data-id="element-114">
            Y mientras tanto…
          </p>
          <p className="text-lg md:text-xl text-accent italic" data-id="element-115">
            hay personas haciendo dinero con herramientas que tú ya tienes a tu
            alcance.
          </p>
        </motion.div>
      </div>
    </section>;
}